import { useState, useRef, useEffect } from 'react'

export function InlineTextEdit({ value, onSave, onCancel, bold }: {
  value: string; onSave: (v: string) => void; onCancel: () => void; bold?: boolean
}) {
  const ref = useRef<HTMLInputElement>(null)
  const [draft, setDraft] = useState(value)
  useEffect(() => { ref.current?.focus(); ref.current?.select() }, [])
  return (
    <input
      ref={ref}
      value={draft}
      onChange={e => setDraft(e.target.value)}
      onBlur={() => { if (draft.trim() && draft !== value) onSave(draft.trim()); else onCancel() }}
      onKeyDown={e => { if (e.key === 'Enter') { e.currentTarget.blur() } else if (e.key === 'Escape') onCancel() }}
      className="w-full bg-transparent outline-none border-b"
      style={{
        fontWeight: bold ? 600 : 500,
        fontSize: 13,
        color: 'var(--color-text)',
        borderColor: 'var(--color-accent)',
        padding: '1px 0',
      }}
    />
  )
}

export function InlineSelect<T extends string>({ value, options, onSave, onCancel }: {
  value: T | null; options: Record<string, string>; onSave: (v: T) => void; onCancel: () => void
}) {
  const ref = useRef<HTMLSelectElement>(null)
  useEffect(() => { ref.current?.focus() }, [])
  return (
    <select
      ref={ref}
      value={value ?? ''}
      onChange={e => { onSave(e.target.value as T) }}
      onBlur={onCancel}
      className="outline-none rounded text-[12px] py-0.5 px-1 cursor-pointer"
      style={{
        background: 'var(--color-warm-50)',
        border: '1px solid var(--color-accent)',
        color: 'var(--color-text)',
        fontFamily: 'var(--font-sans)',
      }}
    >
      <option value="">None</option>
      {Object.entries(options).map(([k, label]) => (
        <option key={k} value={k}>{label}</option>
      ))}
    </select>
  )
}
